import {
  IconBook,
  IconCalendarClock,
  IconChartBar,
  IconClipboardList,
  IconFileCheck,
  IconFileInvoice,
  IconReportAnalytics,
  IconTags,
  type IconProps,
} from "@tabler/icons-react";
import type { ComponentType } from "react";

type TablerIcon = ComponentType<IconProps>;

/**
 * Elige un ícono acorde al CONTENIDO del reporte a partir de su nombre. Los
 * reportes predefinidos vienen del seeder (nombres estables), pero el mapeo es
 * por palabras clave para que cualquier reporte nuevo caiga en un ícono
 * razonable en vez de una estrella genérica. El orden importa: lo más específico
 * primero. Default: `IconReportAnalytics`.
 */
export function iconoDeReporte(nombre: string): TablerIcon {
  const n = nombre
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, ""); // sin acentos

  if (n.includes("clave") || n.includes("catalogo")) return IconTags;
  if (n.includes("contabiliz")) return IconBook;
  if (n.includes("programad") || n.includes("pago programad")) return IconCalendarClock;
  if (n.includes("estatus") || n.includes("validad") || n.includes("fiscal")) return IconFileCheck;
  if (n.includes("emisor") || n.includes("monto")) return IconFileInvoice;
  if (n.includes("organiz") && n.includes("estado")) return IconClipboardList;
  if (n.includes("resumen") || n.includes("organiz")) return IconChartBar;
  if (n.includes("cfdi")) return IconFileInvoice;
  if (n.includes("solicitud")) return IconClipboardList;
  return IconReportAnalytics;
}

/** Render directo del ícono de un reporte (color de marca por defecto). */
export function IconoReporte({
  nombre,
  size = 18,
  className = "text-multiva-600",
}: {
  nombre: string;
  size?: number;
  className?: string;
}) {
  const Icono = iconoDeReporte(nombre);
  return <Icono size={size} className={className} />;
}
